export default __webpack_public_path__ + "static/media/backArrow.1971f371.svg";